<div class="add-credit-payment">
  <div class="ui-g-12 p-zero dialog-header">
    <div class="credit-memo-dialog-heading">Apply credit payment</div>
    <i class="fal fa-times fa-sm dialog-close" (click)="closePaymentModal({})"></i>
  </div>

  <div class="dialog-body">
    <div style="height: 100%" class="ui-g">
      <div style="height: 100%" class="ui-g-12 p-zero">
        <!-- Start Left panel -->
        <div class="ui-g-8 p-zero left-box">
          <div class="ui-g-12 p-0 mb-10px">
            <div class="customer not-allowed">
              <label class="font-14 font-bold mb-4px font-gray-35">Order</label>
              <div class="input-box">
                <div class="font-12 title-icon">
                  <div class="icon-wrapper" *ngIf="payment?.estimate?.isActive">
                    <i class="fal fa-file-alt file-icon"></i>
                  </div>
                  <div class="icon-wrapper" *ngIf="!payment?.estimate?.isActive">
                    <i class="fal fa-lock lock-icon"></i>
                  </div>
                  <div class="font-light capitalize font-bold code-title text-truncate">{{ payment?.estimate?.code }} - {{ payment?.estimate?.title || defaultTitle }}</div>
                  <div class="font-light font-capitalize text-right workflow-status">
                    {{ payment?.estimate?.workFlowStatus }}
                  </div>
                </div>
                <div class="font-10">
                  <div class="font-light customer-email-phone">
                    {{ displayNameEmail(payment?.customer?.displayName, payment?.customer?.email) }}
                    <span *ngIf="payment?.customer?.phone"> - ({{ payment?.customer?.phone | mask : '(000) 000-0000' }})</span>
                  </div>
                  <div class="font-light"></div>
                </div>
              </div>
            </div>
          </div>

          <!-- Payment Input -->
          <div class="ui-g-12 p-0 payment-completed mb-20">
            <div class="ui-g-4 p-0 pr-2">
              <label class="font-14 font-bold mb-4px font-gray-35 width-150">Credit amount*</label>
              <app-input
                id="payment-amount"
                placeholder="$0.00"
                theme="border"
                [fontSize]="13"
                [selectTextOnFocus]="true"
                [hasHoverBorderBottom]="false"
                [hasHoverEffect]="false"
                [value]="payment.creditToApply | currency : usd"
                [disabled]="true"
              >
              </app-input>
            </div>
            <div class="ui-g-4 p-0 pr-2">
              <label class="font-14 font-bold mb-4px font-gray-35">Date</label>
              <div>
                <div class="calendar-input flex-between-center payment-date pointer">
                  <p-calendar
                    id="payment-date"
                    placeholder="Date"
                    styleClass="payment-pointer"
                    appendTo="body"
                    [(ngModel)]="payment && payment.paymentDate"
                    [readonlyInput]="true"
                    [maxDate]="maxDateRange"
                    dateFormat="M d, yy"
                    (onSelect)="onDateTimeChange($event)"
                    #paymentDateTimeEl
                  ></p-calendar>
                  <i class="fal fa-calendar" (click)="paymentDateTimeEl.showOverlay()"></i>
                </div>
              </div>
            </div>
            <div class="ui-g-4 p-0">
              <label class="font-14 font-bold mb-4px font-gray-35">Time*</label>
              <div>
                <kendo-timepicker [(value)]="paymentTime" [formatPlaceholder]="{ hour: 'hh', minute: 'mm' }"> </kendo-timepicker>
              </div>
            </div>
          </div>
          <!-- Payment Input end -->

          <div class="ui-g-12 p-0 mb-10px">
            <label class="font-14 font-bold mb-4px font-gray-35"> Available credits </label>
            <table class="applied-ro">
              <tr>
                <th class="title">Memo #</th>
                <th class="amount">Initial credit</th>
                <th class="amount">Remaining</th>
                <th class="apply-now">Apply now</th>
              </tr>
              <tr *ngFor="let credits of availableCredits; let i = index">
                <td *ngFor="let col of cols" [ngClass]="col.class">
                  <span *ngIf="col.field === 'code'">
                    {{ credits[col.field] }}
                  </span>
                  <span *ngIf="col.field === 'amount' || col.field === 'remainingAmount'">
                    {{ credits[col.field] | currency : usd }}
                  </span>
                  <span *ngIf="col.field === 'appliedAmount'">
                    <app-input
                      id="apply-credit-amount"
                      placeholder="$0.00"
                      theme="border"
                      [fontSize]="12"
                      validationId="error-first-name"
                      [errorMessage]=""
                      [isInvalid]="credits['error']"
                      [selectTextOnFocus]="true"
                      [hasHoverBorderBottom]="false"
                      [hasHoverEffect]="false"
                      styleClass=""
                      [allowDecimal]="credits['focus'] ? true : false"
                      [autoFocus]="credits['focus']"
                      [value]="credits['focus'] ? credits[col.field] : (credits[col.field] | currency : usd)"
                      (appChange)="handleChange($event, i)"
                      (appFocus)="handleFocus(i)"
                      (appBlur)="removeFocus(i)"
                      maxlength="7"
                    >
                    </app-input>
                  </span>
                </td>
              </tr>
            </table>
            <div [hidden]="!remainingBalanceValidation" class="error-label mt-2">
              <i class="fal fa-info-circle text-dark"></i>
              Credit amount must be less than the remaining balance
            </div>
          </div>

          <!-- Notes -->
          <div class="ui-g-12 p-0">
            <label class="font-14 font-600 mb-4px font-gray-35">Notes</label>
            <div class="form-group custom-text-area font-14 notes">
              <textarea id="payment-notes" name="notes" placeholder="Notes" rows="8" (ngModelChange)="onChangeNote($event)" [(ngModel)]="payment.notes"></textarea>
            </div>
          </div>
        </div>

        <!-- Start Right Panel -->
        <div class="ui-g-4 p-zero right-box">
          <!--  Payment History -->
          <div class="ui-g-12 p-0 payment-history">
            <div class="label-row mb-1">
              <label class="label-heading font-13 font-600">Payment summary</label>
            </div>
          </div>
          <div class="ui-g-12 p-0 mb-2 border-bottom">
            <div class="label-row mb-1 border-bottom">
              <div class="label-heading">Total order value</div>

              <div class="label-value">
                {{ payment.estimate.total | currency : usd }}
              </div>
            </div>

            <div class="label-row mb-1 mt-2">
              <div class="label-heading">Paid to date</div>

              <div class="label-value">
                {{ payment.estimate.paid || 0 | currency : usd }}
              </div>
            </div>

            <div class="label-row mb-1 mt-2">
              <div class="label-heading">Credit to apply</div>

              <div class="label-value">
                {{ payment.creditToApply || 0 | currency : usd }}
              </div>
            </div>
          </div>

          <div class="ui-g-12 p-0 mb-2">
            <div class="label-row">
              <div class="label-heading">Remaining balance</div>

              <div class="label-value" [ngClass]="{ 'zero-balance': remainingBalance === 0 }">
                {{ remainingBalance || 0 | currency : usd }}
              </div>
            </div>
          </div>
        </div>
        <!-- End Right Panel -->
      </div>
    </div>
  </div>

  <div class="ui-g-12 p-zero dialog-footer">
    <div class="flex-end-center">
      <button class="btn btn-border pointer btn-submit mr-1" (click)="closePaymentModal($event)">Cancel</button>
      <button class="btn btn-submit btn-primary" (click)="onSubmit(false)" [disabled]="remainingBalanceValidation">
        <span [ngClass]="{ 'pr-2': isProcessing }">Save</span>
        <i *ngIf="isProcessing" class="fal fa-spinner rotate"></i>
      </button>
    </div>
  </div>
</div>
